import SearchIcon from "@mui/icons-material/Search";
import { Box, Grid, styled, Tab, TextField } from "@mui/material";
import { api, types } from "api";
import { UUID } from "api/types";
import { ColorTabs } from "components/ColorTabs";
// import { useBreadcrumbs } from "helpers/useBreadcrumbs";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { routes } from "routes";
import { useAuthStatus } from "../../helpers/useAuthStatus";
import { GET_RESULT_FAIL } from "../../messages";
import { StudentTable } from "./Component/StudentTable";

const PREFIX = "StudentTablePage";

const classes = {
	root: `${PREFIX}-root`,
	tabs: `${PREFIX}-tabs`,
	tabsBarBox: `${PREFIX}-tabsBarBox`,
	button: `${PREFIX}-button`,
	buttonList: `${PREFIX}-buttonList`,

	appBar: `${PREFIX}-appBar`,
	indicator: `${PREFIX}-indicator`,
	table: `${PREFIX}-table`,
};

const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	[`& .${classes.tabs}`]: {
		color: "white",
	},
	[`& .${classes.tabsBarBox}`]: {
		backgroundColor: theme.palette.primary.main,
	},
	[`& .${classes.button}`]: {
		minWidth: theme.spacing(21),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	[`& .${classes.buttonList}`]: {
		display: "flex",
	},

	[`& .${classes.appBar}`]: {
		backgroundColor: theme.palette.primary.main,
	},

	[`& .${classes.table}`]: {
		marginTop: theme.spacing(4),
	},
}));

export const StudentTablePage = (): JSX.Element => {
	const { role } = useAuthStatus();
	const [studentName, setStudentName] = useState("");
	// const { updateLastBreadcrumbs } = useBreadcrumbs();
	const [, setErr] = useState("");
	const [students, setStudents] = useState<types.User[]>([]);
	const [allStudents, setAllStudents] = useState<types.User[]>([]);
	// const [loading, setLoading] = useState(true);
	const params = useParams<{ groupId: UUID }>();
	const [isloading, setIsloading] = useState(true);

	const fetchGroupUser = useCallback((groupId: UUID) => {
		api
			.getGroupUsers(groupId, { role: "student" })
			.then((res) => {
				if (res.status !== 200) {
					throw new Error();
				}
				setErr("");
				if (res.data === null || res.data.length === 0) {
					setStudents([]);
					return;
				}
				setStudents(res.data);
				setAllStudents(res.data);
				setIsloading(false);
			})
			.catch(() => {
				setErr(GET_RESULT_FAIL);
			});
	}, []);

	const fetchStudents = useCallback(() => {
		api
			.getUsers({ role: "student" })
			.then((res) => {
				if (res.status !== 200) {
					throw new Error();
				}
				setErr("");
				if (res.data === null || res.data.length === 0) {
					setStudents([]);
					return;
				}
				setStudents(res.data);
				setAllStudents(res.data);
				setIsloading(false);
			})
			.catch(() => {
				setErr(GET_RESULT_FAIL);
			});
	}, []);

	useEffect(() => {
		if (params.groupId !== undefined) {
			fetchGroupUser(params.groupId);
		} else {
			if (role === "admin" || role === "teacher" || role === "admin-teacher") {
				fetchStudents();
			}
		}
	}, [role, fetchStudents, fetchGroupUser, params.groupId]);

	return (
		<Root className={classes.root}>
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				className={classes.tabsBarBox}
			>
				<ColorTabs
					value={routes._.metrics._.Students.path}
					variant="scrollable"
					scrollButtons
				>
					<Tab
						label="GROUP LIST"
						value={routes._.metrics._.Groups.path}
						sx={{ color: "white" }}
						classes={{
							root: classes.tabs,
						}}
						component={Link}
						to={routes._.metrics._.Groups.path}
					/>
					<Tab
						label="STUDENT LIST"
						value={routes._.metrics._.Students.path}
						sx={{ color: "white" }}
						classes={{
							root: classes.tabs,
						}}
						component={Link}
						to={routes._.metrics._.Students.path}
					/>
					<Tab
						label="School Metrics"
						value={routes._.metrics._.School.path}
						sx={{ color: "white" }}
						classes={{
							root: classes.tabs,
						}}
						component={Link}
						to={routes._.metrics._.School.path}
					/>
					{role === "admin" && (
						<Tab
							label="Registered Users"
							value={routes._.metrics._.RegisteredUsers.path}
							sx={{ color: "white" }}
							classes={{
								root: classes.tabs,
							}}
							component={Link}
							to={routes._.metrics._.RegisteredUsers.path}
						/>
					)}
				</ColorTabs>
			</Box>

			<StudentTable students={students} isloading={isloading}>
				<Grid item xs={4}>
					{/* student search box */}
					{/* <TextField
						id="group-name"
						label="Student Name"
						variant="outlined"
						value={studentName}
						onChange={(e) => {
							setStudentName(e.target.value);
						}}
						fullWidth
						InputProps={{
							endAdornment: <SearchIcon />,
						}}
					/> */}
					<TextField
						id="group-name"
						label="Student Name"
						variant="outlined"
						value={studentName}
						onChange={(e) => {
							const searchName = e.target.value;
							if (searchName.length < studentName.length) {
								// monitor backspace
								setStudents(allStudents);
							} else {
								let searchStudents: Array<types.User> = [];
								const regex = /^ *$/;
								// a name is null or empty string or all whitespace
								if (regex.exec(searchName) !== null) {
									setStudents(allStudents);
								} else {
									students.forEach((student) => {
										const name = student.firstName + " " + student.lastName;
										if (
											name
												.toLowerCase()
												.includes(searchName.trim().toLowerCase())
										) {
											searchStudents = [...searchStudents, student];
										}
									});
									setStudents(searchStudents);
								}
							}
							setStudentName(searchName);
						}}
						fullWidth
						InputProps={{
							endAdornment: <SearchIcon />,
						}}
					/>
				</Grid>
			</StudentTable>
		</Root>
	);
};
